import { createContext } from "react";

import { TooltipFooter } from "./types";

// Context rather than a slot prop: the slot is typed as the library's own tooltip props, and a stable slot component never remounts mid-hover.
export const TooltipFooterContext = createContext<TooltipFooter | undefined>(
  undefined,
);
